import {  useEffect, useState } from 'react';
import CommonLoader from '../common/CommonLoader.jsx';
import { callApi } from '../../services/ApiServices.js';
import { ImagePath } from './ImagePath.js';
import { formatTimestamp } from '../../utlis/function.js';
import CommonPagination from './CommonPagination.jsx';

const PayoutTransactions = ({
  onClose,
   clubDetail
}) => {
    const [loading, setLoading] = useState(false)
    const [transactions, setTransactions] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(1);
    const limit = 15;


    useEffect(()=>{
        getPayoutTransactions(currentPage, limit)
    },[])
 
    const getPayoutTransactions = async (page, limit) => {
      setLoading(true);
      try {
        let url = `/admin/payouts/${clubDetail?.club_id}?page=${page}&limit=${limit}`;
        const response = await callApi({
          method: "get",
          url: url
        });
        setTransactions(response?.data || []);
        const totalItems = response?.pagination?.total || 0;
        setTotalCount(totalItems > 0 ? Math.ceil(totalItems / limit) : 1);
        console.log("Payout transactions", response);
      } catch (error) {
        console.log("Error fetching payout transactions", error);
      } finally {
        setLoading(false);
      }
    };

  const handlePageChange =(e)=>{
  setCurrentPage(e)
  getPayoutTransactions(e, limit)
}
  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
<div className="bg-white rounded-[20px] max-w-[1000px] max-h-[1200px] overflow-y-auto w-full mx-4 relative shadow animate-fade-in">
      <div className="bg-white rounded-[12px] shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
            <div className='flex justify-between px-4 py-4 '>
                <h2 className='text-[25px] font-semibold text-black '>Payout Transactions</h2>
                <button onClick={onClose} className='text-gray-500 hover:text-gray-700 cursor-pointer text-[25px]'>&times;</button>
                
            </div>
            <div className='container '>
          <table className="w-full mb-4">
            {/* Table Header */}    
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  S no.
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">Date</th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Amount
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Description
                </th>
                
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="py-10 text-center">
                    <div className="flex items-center justify-center">
                      {/* <CommonLoader fullScreen /> */}
                    </div>
                  </td>
                </tr>
              ) : transactions?.length > 0 ? (
                transactions?.map((item, index) => (
                  <tr
                    key={item.id}
                    className={`border-b border-gray-100 hover:bg-gray-50 transition-colors border-b-0`}
                  >
                    <td className='px-6 py-3'>{(currentPage -1) * limit + index + 1}</td> 
                    <td className='px-6 py-3'>{formatTimestamp(item?.createdAt)}</td>
                    {/* Amount */}
                    <td className="px-6 py-3">
                      <div className="text-sm text-textcolor">
                        {item.amount ? `$${item.amount}` : "-"}
                        <br />
                      </div>
                    </td>

                    {/* Total Revenue */}
                    <td className="px-6 py-3">
                      <span className="text-sm font-medium text-textcolor">
                        {item.description
                          ? (item.description)
                          : "-"}
                      </span>
                    </td>

                           
                  </tr>
                ))
              ) : (
                !loading && (
                  <tr>
                    <td
                      colSpan="4"
                      className="px-6 py-3 text-sm font-normal text-textcolor"
                    >
                      <div className="flex justify-center items-center mt-5">
                        <img
                          src={ImagePath?.NoDataFound}
                          alt="No Data Found"
                          style={{ width: 70, height: 70 }}
                        />
                      </div>
                      <p className="text-xl mt-2 text-center">No data found</p>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
          </div>
        </div>
      </div>
      <div className='mb-4 flex justify-end px-4'>
      <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={(e) => handlePageChange(e)}
      />
      </div>
      </div>
    </div>
  );
};

export default PayoutTransactions;

